module.exports = __webpack_public_path__ + "media/warranty-claim/photos-close-up2-dc9454b9.png";